// extracted by mini-css-extract-plugin
export default {"loadcontainer":"LogIn_loadcontainer__QNf2b","container":"LogIn_container__DaRm8","innerBox":"LogIn_innerBox__EEJ24","footer":"LogIn_footer__yPU-f","error":"LogIn_error__47wbR"};